import { defineStyleConfig } from '@chakra-ui/system';

export const Progress = defineStyleConfig({
    baseStyle: {
        filledTrack: { backgroundColor: 'slt-pepper.1000' },
        track: { backgroundColor: 'slt-pepper.100' },
    },
    variants: {
        cart: {
            filledTrack: { backgroundColor: 'slt-primary-green.1000' },
            track: { backgroundColor: 'white', border: '1px solid #414042' },
        },
    },
});
